import React from "react";
import { Award, Users, TrendingUp, Shield } from "lucide-react";

const AboutSection = () => {
  const stats = [
    { icon: <Award />, number: "1000+", label: "Trademarks Filed" },
    { icon: <Users />, number: "850+", label: "Happy Clients" },
    { icon: <TrendingUp />, number: "98%", label: "Success Rate" },
    { icon: <Shield />, number: "15+", label: "Years Experience" },
  ];

  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">About trademarkIcontext</h2>
          <p className="section-subtitle">
            Your Trusted Partner in Trademark Protection
          </p>
        </div>

        <div className="about-content">
          <div className="about-text-card">
            <h3 className="about-heading">Who We Are</h3>
            <p className="about-paragraph">
              trademarkIcontext is a leading trademark registration service provider specializing in helping businesses, entrepreneurs, and innovators protect their brand identities across the United States. With over 15 years of experience in intellectual property law and trademark filing, we have successfully registered over 1,000 trademarks with the United States Patent and Trademark Office (USPTO).
            </p>
            <p className="about-paragraph">
              Our team of experienced trademark attorneys and filing specialists understands the complexities of the USPTO registration process. We guide you through every step - from comprehensive trademark searches to handling office actions and monitoring your registered marks. Our mission is to make trademark protection accessible, affordable, and stress-free for businesses of all sizes.
            </p>
            <p className="about-paragraph">
              We pride ourselves on our personalized approach, treating each client's brand with the care and attention it deserves. Whether you're a startup launching your first product or an established company expanding your brand portfolio, we provide expert guidance tailored to your specific needs and business goals.
            </p>
          </div>

          <div className="stats-grid">
            {stats.map((stat, index) => (
              <div key={index} className="stat-card">
                <div className="stat-icon">{stat.icon}</div>
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
